import { Audio60, Brand70, Brand80, Danger500, Neutral400 } from '@src/utils/colors';

export const DATE_FORMAT = 'yyyy-MM-dd';
export const DEFAULT_WEEKS_BACK = 12;

export const GROSS_LABEL = 'Gross';
export const NET_LABEL = 'Net';
export const SPEND_OPTIONS = [GROSS_LABEL, NET_LABEL] as const;
export type SpendDimension = (typeof SPEND_OPTIONS)[number];

export const ACCEPTED_LABEL = 'Accepted';
export const ALL_LABEL = 'All';
export const ACCEPTED_OPTIONS = [ACCEPTED_LABEL, ALL_LABEL] as const;
export type AcceptedDimension = (typeof ACCEPTED_OPTIONS)[number];

export const MEDIA_TYPE_UNSECURED = 'Unsecured';
export const MEDIA_TYPE_SECURED = 'Secured';
export const MEDIA_TYPE_UPFRONT = 'Upfront';
export const MEDIA_TYPE_ALL = 'All';
export const MEDIA_TYPE_OPTIONS = [
  MEDIA_TYPE_UNSECURED,
  MEDIA_TYPE_SECURED,
  MEDIA_TYPE_UPFRONT,
  MEDIA_TYPE_ALL
] as const;
export type MediaTypeDimension = (typeof MEDIA_TYPE_OPTIONS)[number];

export const COMPANY_DIMENSION = 'company';
export const COMPANY_LABEL = 'Company';
export const NETWORK_DIMENSION = 'network';
export const NETWORK_LABEL = 'Network';
export const PRIMARY_DIMENSION_OPTIONS = [
  { key: COMPANY_DIMENSION, label: COMPANY_LABEL },
  { key: NETWORK_DIMENSION, label: NETWORK_LABEL }
] as const;
export type PrimaryDimension = typeof COMPANY_DIMENSION | typeof NETWORK_DIMENSION;

export const TAB_CLIENT_DETAIL = 'Client Detail';
export const TAB_CLEARANCE = 'Historical Clearance';
export const TAB_CLEARANCE_VS_FORECAST = 'Clearance Vs. Forecast';
export const TAB_BY_CAMPAIGN = 'By Campaign';
export const NAVS = [
  { key: TAB_CLIENT_DETAIL, label: TAB_CLIENT_DETAIL },
  { key: TAB_CLEARANCE, label: TAB_CLEARANCE },
  { key: TAB_CLEARANCE_VS_FORECAST, label: TAB_CLEARANCE_VS_FORECAST },
  { key: TAB_BY_CAMPAIGN, label: TAB_BY_CAMPAIGN }
];

// Clearance and forecast chart colors: the closest token (CIEDE2000) to each bpm-frontend color,
// limited to tokens that colors.scss also defines. Mirrored in LinearPacing.scss.
export const CLEARANCE_CHART_COLORS = {
  clearance: Audio60,
  forecastDark: Neutral400,
  actual: Brand80,
  lowReference: Brand70,
  highReference: Danger500
};
export const CLEARANCE_CHART_MARGIN = { top: 4, right: 32, left: 8, bottom: 4 };
export const CLEARANCE_LOW_REFERENCE = 65;
export const CLEARANCE_HIGH_REFERENCE = 85;
